export default "__VITE_ASSET__Dr243q_x__"